export const ACCORDION_QUESTION_TYPES_WIDTH = 300
export const ACCORDION_SUMMARY_WIDTH = 300
export const MIN_WIDTH_BEFORE_RESIZING = 1320
export const EDIT_TARGETING_FIXED_CONTENT_HEIGHT = 190 // header+subheader+summary

export const SCROLL_ID_PREFIX = 'scroll-id-'
export const AUDIENCE_SCROLL_CONTAINER_ID = 'aud-scroll-c'

export const TARGETING_CRITERIA_CODES_FOR_NON_FD_USERS = new Set([
  '21.what_is_your_professional_position_in_the_company_you_work_for?',
  '22.approximately_how_many_employees_work_at_your_organization_(all_locations)?',
  '393.could_you_tell_us_what_the_profession_of_the_chief_income_earner_in_your_household_is?',
  '401.if_you_work_in_the_public_sector,_which_profession_are_you?'
])
